export const FLICKING_TIMEGAP = 100;
export const FLICKING_DISTANCE = 40;
export const HORIZONTAL_MOVE_DISTANCE = 20;
export const LONGPRESS_TIMEGAP = 150;
export const DURATION = 700;
